<template>
  <v-toolbar class="ml-4 limit wd-100" color="transparent">
    <v-toolbar-title style="font-size: 24px; font-weight: bold"
      >{{ this.projeto }} - Testes de Equipe</v-toolbar-title
    >
    <v-col cols="12" sm="6" md="3">
      <v-text-field
        label="Buscar por CSU ou tarefa"
        prepend-inner-icon="mdi-magnify"
        single-line
        hide-details
        density="compact"
        class="mr-n2"
        variant="solo"
        v-model="search"
      ></v-text-field>
    </v-col>
  </v-toolbar>
  <v-table
    class="ma-8 mt-1 elevation-1 table"
    style="background: transparent"
    :fixed-header="true"
    density="comfortable"
  >
    <thead class="text-grey">
      <tr>
        <th class="rounded-ts-lg pl-10 text-left text-grey">Caso de Uso</th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Status
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Tarefa
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Status da tarefa
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Num. Bugs Encontrados
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="rounded-te-lg text-center text-grey"
        >
          Num. Bugs Corrigidos
        </th>
      </tr>
    </thead>
    <div class="split"></div>

    <tbody>
      <tr v-for="(teste, index) in filteredLista" :key="index">
        <td class="pl-10 text-left">{{ teste.nome_csu }}</td>
        <td style="border-left: thin solid #efefef" class="text-center">
          {{ teste.status_csu }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-center">
          {{ teste.tarefa || '-' }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-center">
          {{ teste.status_tarefa || '-' }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-center">
          {{ teste.qtd_bugs || '-' }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-center">
          {{ teste.qtd_bugs_corrigidos || '-' }}
        </td>
      </tr>
    </tbody>
  </v-table>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script>
/**
 * @module TestesIndependentes
 * @desc Tela que mostra a cobertura dos testes independentes.
 *
 * @vue-data {Array.<Object>} [coberturas=[]] Lista de objetos, cada um
 * deles guarda informações sobre a cobertura de um caso de uso
 * @vue-data {Number} [idProjeto=0] O id do projeto que está relacionado com
 * os casos de uso
 * @vue-data {Boolean} [isLoading=false] Flag que indica se os dados já foram
 * carregados
 * @vue-data {String} [search=''] String que armazena a entrada no campo de
 * busca
 * @vue-data {String} [projeto=''] Nome do projeto
 * @vue-computed {Array.<Object>} filteredLista - A lista coberturas
 * filtrada de acordo com o termo de busca
 */
import axios from 'axios';

import store from '@/store/store';

export default {
  data() {
    return {
      testes: [],
      idProjeto: 0,
      projeto: '',
      isLoading: false,
      search: '',
    };
  },
  created() {
    this.idProjeto = Number(this.$route.params.idProjeto);
    this.projeto = localStorage.getItem('projeto');

    this.getCoberturaTestes();
  },
  computed: {
    filteredLista() {
      if (this.search.trim().length > 0) {
        return this.testes.filter(
          (teste) =>
            teste.nome_csu
              .toLowerCase()
              .includes(this.search.trim().toLowerCase()) ||
            teste.tarefa
              .toLowerCase()
              .includes(this.search.trim().toLocaleLowerCase()),
        );
      }

      return this.testes;
    },
  },
  methods: {
    /**
     * Obtém uma lista de objetos, cada um deles guarda informações sobre
     * a cobertura de um caso de uso.
     */
    getCoberturaTestes() {
      const apiUrl = process.env.VUE_APP_API_URL;
      this.isLoading = true;

      axios
        .get(
          `${apiUrl}/api/v1/cobertura/projeto/${this.idProjeto}/testes-equipe`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        )
        .then((res) => {
          this.testes = JSON.parse(res.data);
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.table tbody tr {
  background-color: #fff;
}
</style>
